import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { Grid } from '@material-ui/core'
import { paths } from 'config'
import ReadingRobot from 'shared/images/reading_robot.png'
import {
  Button,
  Wrapper,
  Title,
  Text,
  Image,
} from './NoSubscriptionBanner.style'

interface NoSubscriptionBannerProps {}

const NoSubscriptionBanner = (props: NoSubscriptionBannerProps) => {
  const { t } = useTranslation()
  const history = useHistory()

  const onClick = () => history.push(paths.subscription)

  return (
    <Wrapper
      container
      direction="column"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Image src={ReadingRobot} />
      <Grid item xs={8}>
        <Title>{t('noSubscription.title')}</Title>
        <Text>{t('noSubscription.description')}</Text>
      </Grid>
      <Button
        variant="contained"
        color="primary"
        onClick={onClick}
        fullWidth={false}
      >
        {t('noSubscription.getSubscription')}
      </Button>
    </Wrapper>
  )
}

export default NoSubscriptionBanner
